<template>
  <b-navbar toggleable="lg" class="navbar-bee sticky-top">
    <b-navbar-brand class="mr-0">
      <router-link to="/">
        <img
          class="app__logo"
          src="../assets/images/logo.svg"
          alt="Logo adpotuj"
        />
      </router-link>
    </b-navbar-brand>
    <div class="form__show d-lg-none" v-b-modal="'modal-payment'">ADOPTUJĘ</div>

    <b-navbar-toggle target="nav-collapse">
      <div class="bar1"></div>
      <div class="bar2"></div>
      <div class="bar3"></div>
    </b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto">
        <li class="nav-item">
          <router-link class="nav-link d-lg-none" to="/"
            >Strona główna
          </router-link>
        </li>
        <b-nav-item
          v-if="content.data.about.visible"
          id="about-nav"
          @click="toggleQA('about')"
        >
          <img
            src="../assets/images/10/nav/pszczola.svg"
            class="non-active"
            alt="ikona pszczoły"
          />
          <img
            src="../assets/images/10/nav/pszczola_active.svg"
            class="active"
            alt="ikona pszczoły"
          />
           {{content.data.about.nav_name}}</b-nav-item
        >
        <b-nav-item
          id="pakiet-pszczelego-bohatera-nav"
          @click="toggleQA('pakiet-pszczelego-bohatera-mp')"
        >
          <img
            src="../assets/images/10/nav/gift.svg"
            class="non-active"
            alt="ikona prezentu"
          />
          <img
            v-if="content.data.hero_pack.visible"
            src="../assets/images/10/nav/gift_active.svg"
            class="active"
            alt="ikona prezentu"
          />
           {{content.data.hero_pack.nav_name}}</b-nav-item
        >
        <b-nav-item v-if="content.data.teasers.visible" @click="over10Img">
          <img
            src="../assets/images/10/nav/pszczola.svg"
            class="rotate_10 non-active"
            alt="ikona pszczoły"
          />
          <img
            src="../assets/images/10/nav/pszczola_active.svg"
            class="rotate_10 active"
            alt="ikona pszczoły"
          />
          {{content.data.teasers.nav_name}}</b-nav-item
        >
        <li class="nav-item" v-if="content.data.about_bees.visible">
          <router-link class="nav-link" to="/o-pszczolach"
            ><img
              src="../assets/images/10/nav/pszczola.svg"
              class="rotate_faq non-active"
              alt="ikona pszczoły"
            />
            <img
              src="../assets/images/10/nav/pszczola_active.svg"
              class="rotate_faq active"
              alt="ikona pszczoły"
            />
            {{content.data.about_bees.nav_name}}</router-link
          >
        </li>
        <li class="nav-item" v-if="content.data.faq.visible">
          <router-link class="nav-link" to="/pytania-i-odpowiedzi"
            ><img
              src="../assets/images/10/nav/pszczola.svg"
              class="rotate_faq non-active"
              alt="ikona pszczoły"
            />
            <img
              src="../assets/images/10/nav/pszczola_active.svg"
              class="rotate_faq active"
              alt="ikona pszczoły"
            />
            {{content.data.faq.nav_name}}</router-link
          >
        </li>

        <div class="font-icon">
          <div
            v-if="regularFont"
            title="Czcionka średnia"
            @click="toggleMiddleFontView()"
          >
            <img
              src="../assets/images/font-plus.svg"
              alt="Czcionka średnia ikona"
            />
          </div>

          <div
            v-if="middleFont"
            title="Czcionka duża"
            @click="toggleBigFontView()"
          >
            <img
              src="../assets/images/font-plus.svg"
              alt="Czcionka duża ikona"
            />
          </div>

          <div
            v-if="bigFont"
            title="Czcionka domyślna"
            @click="toggleRegularFontView()"
          >
            <img
              src="../assets/images/font-minus.svg"
              alt="Czcionka domyślna ikona"
            />
          </div>
        </div>
        <div
          class="contrast-icon"
          title="Kontrast żółto-czarny"
          @click="toggleShowContrast()"
        >
          <img
            src="../assets/images/font-contrast.svg"
            alt="Kontrast żółto-czarny ikona"
            class="mb-1"
          />
        </div>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  name: "Nav",
  inject: ["content", "appData"],
  data() {
    return {
      title: "Navigacja",
      regularFont: true,
      middleFont: false,
      bigFont: false,
    };
  },
  components: {},

  methods: {
    scrollToElement(id) {
      let positionOfElement = document.getElementById(id).offsetTop;
      if (window.innerWidth < 1200) {
        window.scroll({
          top: positionOfElement + 425,
          left: 0,
          behavior: "smooth",
        });
      } else {
        window.scroll({
          top: positionOfElement,
          left: 0,
          behavior: "smooth",
        });
      }
    },

    toggleShowContrast() {
      this.$emit("show-contrast-view");
    },
    toggleRegularFontView() {
      this.$emit("show-regular-font-view");
      this.regularFont = true;
      this.middleFont = false;
      this.bigFont = false;
    },
    toggleMiddleFontView() {
      this.$emit("show-middle-font-view");
      this.regularFont = false;
      this.middleFont = true;
      this.bigFont = false;
    },
    toggleBigFontView() {
      this.$emit("show-big-font-view");
      this.regularFont = false;
      this.middleFont = false;
      this.bigFont = true;
    },
    toggleQA: function (el) {
      let element = document.getElementById(el);

      if (typeof element != "undefined" && element != null) {
        this.scrollToElement(el);
      } else {
        if (el == "about") {
           if (this.$route.path !== "/pytania-i-odpowiedzi/o-akcji") {
             this.$router.push("/pytania-i-odpowiedzi/o-akcji#o-akcji");
           }
        } else if (el == "bees-and-climate") {
          this.$router.push("/pytania-i-odpowiedzi/dlaczego-zapylacze#dlaczego-zapylacze");
        } else if (el == "pakiet-pszczelego-bohatera-mp") {
          this.$router.push("/pytania-i-odpowiedzi/pakiet-pszczelego-bohatera#pakiet-pszczelego-bohatera");
        } else {
          this.$router.push("/pytania-i-odpowiedzi").catch(() => {});
        }
      }
    },

    over10Img() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }

      this.$root.$emit("showAdditionalNavFn", true);
      this.$root.$emit("scrollToAdditionalNavFn");
    },
  },
};
</script>
<style lang="scss">
.font-icon,
.contrast-icon {
  display: none;
  @media (min-width: 1200px) {
    display: block;
    color: #ffc501;
    background-color: #313131;
    position: fixed;
    left: 0;
    z-index: 999;
    width: 2.4rem;
    font-size: 1.35rem;
    padding: 0.25rem 0.35rem;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  &:hover {
    cursor: pointer;
  }
  a {
    color: #ffc501;
  }
  a:active,
  a:visited {
    cursor: pointer;
    color: #ffc501;
  }
}
.font-icon {
  top: calc(50vh - 5rem);
}
.contrast-icon {
  top: calc(50vh - 2rem);
}
</style>
